import { FormBase } from "@models/portal/users/form-base";
import { IDrawDto } from "../dtos/draw-dto";
import { MetadataPutEnum } from "@models/enums/metadata-put-enum";
import { DrawArenaForm } from "./draw-arena-form";
import { Utils } from "src/app/core/utilities/utils";

export class DrawPostForm extends FormBase {
  sorTxNome?: string;
  sorTxDescricao?: string;
  sorNrMaxJogosDia?: number;
  sorNrIntervaloJogos?: number;
  sorNrMaxEmbSimultaneos?: number;
  sorBlTrocaOrdemConfronto: boolean;
  catNrId?: number;
  incNrIds?: Array<number>;
  arenaSorteioFormList?: Array<DrawArenaForm>;

  constructor() {
    super();
    this.sorBlTrocaOrdemConfronto = false;
    this.incNrIds = [];
    this.arenaSorteioFormList = [];
  }

  public static createFromDto(data: IDrawDto): DrawPostForm {
    const form = new DrawPostForm();
    form.sorTxNome = data.sorTxNome;
    form.sorTxDescricao = data.sorTxDescricao;
    form.sorNrMaxJogosDia = data.sorNrMaxJogosDia;
    form.sorNrIntervaloJogos = data.sorNrIntervaloJogos;
    form.sorNrMaxEmbSimultaneos = data.sorNrMaxEmbSimultaneos;
    form.sorBlTrocaOrdemConfronto = data.sorBlTrocaOrdemConfronto ?? false;
    form.catNrId = data.sorObjCategoria?.catNrId;
    form.entNrId = data.sorNrId;
    form.entTxMetadado = MetadataPutEnum.INALTERADO;
    return form;
  }

  public static of(form: Partial<DrawPostForm>): DrawPostForm {
    const newForm = new DrawPostForm();
    newForm.sorTxNome = form.sorTxNome;
    newForm.sorTxDescricao = form.sorTxDescricao;
    newForm.sorNrMaxJogosDia = form.sorNrMaxJogosDia;
    newForm.sorNrIntervaloJogos = form.sorNrIntervaloJogos;
    newForm.sorNrMaxEmbSimultaneos = form.sorNrMaxEmbSimultaneos;
    newForm.sorBlTrocaOrdemConfronto = form.sorBlTrocaOrdemConfronto ?? false;
    newForm.catNrId = form.catNrId;
    newForm.incNrIds = form.incNrIds ?? [];
    newForm.arenaSorteioFormList = form.arenaSorteioFormList ?? [];
    newForm.entNrId = form.entNrId;
    newForm.entTxMetadado = form.entTxMetadado ?? MetadataPutEnum.CRIADO;
    return newForm;
  }


  public static buildPutForm(newState: DrawPostForm, currentState?: IDrawDto): DrawPostForm {
    const updatedForm = new DrawPostForm();
    updatedForm.sorTxNome = newState.sorTxNome;
    updatedForm.sorTxDescricao = newState.sorTxDescricao;
    updatedForm.sorNrMaxJogosDia = newState.sorNrMaxJogosDia;
    updatedForm.sorNrIntervaloJogos = newState.sorNrIntervaloJogos;
    updatedForm.sorNrMaxEmbSimultaneos = newState.sorNrMaxEmbSimultaneos;
    updatedForm.sorBlTrocaOrdemConfronto = newState.sorBlTrocaOrdemConfronto;
    updatedForm.catNrId = newState.catNrId;
    updatedForm.incNrIds = [...(newState.incNrIds ?? [])];
    updatedForm.arenaSorteioFormList = [...(newState.arenaSorteioFormList ?? [])];
    updatedForm.entNrId = currentState?.sorNrId ?? newState.entNrId;

    let modified = false;
    if (newState.sorTxNome !== currentState?.sorTxNome) modified = true;
    if (newState.sorTxDescricao !== currentState?.sorTxDescricao) modified = true;
    if (newState.sorNrMaxJogosDia !== currentState?.sorNrMaxJogosDia) modified = true;
    if (newState.sorNrIntervaloJogos !== currentState?.sorNrIntervaloJogos) modified = true;
    if (newState.sorNrMaxEmbSimultaneos !== currentState?.sorNrMaxEmbSimultaneos) modified = true;
    if (newState.sorBlTrocaOrdemConfronto !== currentState?.sorBlTrocaOrdemConfronto) modified = true;
    if (newState.catNrId !== currentState?.sorObjCategoria?.catNrId) modified = true;

    const oldIds = (currentState?.sorListCabecasChave ?? []).map(i => i.incNrId).sort();
    const newIds = (newState.incNrIds ?? []).sort();
    if (JSON.stringify(oldIds) !== JSON.stringify(newIds)) modified = true;

    const oldArenas = (currentState?.sorListArenas ?? []).map(a => ({
      areNrId: a.areNrId,
      arsNrEmbatesSimultaneos: a.arsNrMaximoEmbateSimultaneos
    }));
    const newArenas = (newState.arenaSorteioFormList ?? []).map(a => ({
      areNrId: a.areNrId,
      arsNrEmbatesSimultaneos: a.arsNrEmbatesSimultaneos
    }));
    if (JSON.stringify(oldArenas) !== JSON.stringify(newArenas)) modified = true;

    updatedForm.entTxMetadado = modified ? MetadataPutEnum.ALTERADO : MetadataPutEnum.INALTERADO;

    return updatedForm;
  }

  public static markAsDeleted(sorNrId: number, wasDeleted: boolean): DrawPostForm {
    const deleted = new DrawPostForm();
    deleted.entNrId = sorNrId;
    deleted.entTxMetadado = wasDeleted ? MetadataPutEnum.DELETADO : MetadataPutEnum.INALTERADO;
    return deleted;
  }
}
